import React, { useState, useEffect } from "react";
import {
  collection, addDoc, getDocs, deleteDoc, updateDoc,
  doc, query, where, serverTimestamp,
} from "firebase/firestore";
import { db } from "../firebase";
import { connect } from "react-redux";
import genericProfilePic from "../genericprofilepic.png";
import { notifyAllUsers } from "../utils/notificationHelpers";

const COLLECTION_URL = {
  torahCommentaries: '/torah-portion',
  haftarahCommentaries: '/haftarah-portion',
  gospelCommentaries: '/new-testament-portion',
};

function PortionCommentary({ collectionName, portionName, profile_pic_url, first_name, last_name }) {
  const userId = localStorage.getItem("user_id");
  const [text, setText] = useState("");
  const [myCommentaries, setMyCommentaries] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editText, setEditText] = useState("");

  const fetchMine = async () => {
    if (!userId || !portionName) return;
    const snap = await getDocs(
      query(
        collection(db, collectionName),
        where("user_id", "==", userId),
        where("portion", "==", portionName)
      )
    );
    setMyCommentaries(snap.docs.map(d => ({ id: d.id, ...d.data() })));
  };

  useEffect(() => {
    fetchMine();
  }, [portionName, collectionName]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    await addDoc(collection(db, collectionName), {
      user_id: userId,
      portion: portionName,
      commentary: text,
      created_at: serverTimestamp(),
    });
    setText("");
    await fetchMine();

    const fromName = `${first_name || ''} ${last_name || ''}`.trim() || 'Someone';
    const snippet = text.length > 80 ? text.slice(0, 80) + '…' : text;
    notifyAllUsers({
      fromUserId: userId,
      fromName,
      type: 'portion_commentary',
      message: `${fromName} added commentary on the ${portionName} portion: "${snippet}"`,
      url: COLLECTION_URL[collectionName] || '/dashboard',
    }).catch(() => {});
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this commentary?")) return;
    await deleteDoc(doc(db, collectionName, id));
    setMyCommentaries(prev => prev.filter(c => c.id !== id));
  };

  const handleEdit = async (e) => {
    e.preventDefault();
    await updateDoc(doc(db, collectionName, editingId), { commentary: editText });
    setEditingId(null);
    setEditText("");
    await fetchMine();
  };

  return (
    <div>
      <br />
      <div id="pic-mycommentary">
        <img id="smallprofilepic" src={profile_pic_url || genericProfilePic} alt="profile" />
        <br />
        <h3 className="my-commentary-title">My Commentary:</h3>
      </div>

      {myCommentaries.map(c =>
        editingId === c.id ? (
          <div className="roundedbox" key={c.id}>
            <form onSubmit={handleEdit} id={`edit-${c.id}`}>
              <textarea
                className="edittext"
                name="commentary"
                form={`edit-${c.id}`}
                value={editText}
                onChange={e => setEditText(e.target.value)}
              />
              <button id="bigbutton" type="submit" disabled={!editText.trim()}>Save My Commentary</button>
              <button id="bigbutton" type="button" onClick={() => { setEditingId(null); setEditText(""); }}>Cancel</button>
              <br /><br />
            </form>
          </div>
        ) : (
          <div className="roundedbox" key={c.id}>
            <p className="commentary-text">{c.commentary}</p>
            <button onClick={() => { setEditingId(c.id); setEditText(c.commentary); }}>Edit</button>
            <button onClick={() => handleDelete(c.id)}>Delete</button>
          </div>
        )
      )}

      <form onSubmit={handleSubmit} id={`portion-commentary-${collectionName}`}>
        <textarea
          name="commentary"
          form={`portion-commentary-${collectionName}`}
          value={text}
          onChange={e => setText(e.target.value)}
          placeholder="Write your commentary here..."
        />
        <button id="bigbutton" type="submit">Save My Commentary</button>
      </form>
    </div>
  );
}

const mapStateToProps = (state) => ({
  profile_pic_url: state.profile_pic_url,
  first_name: state.first_name,
  last_name: state.last_name,
});

export default connect(mapStateToProps, {})(PortionCommentary);
